import { BCMSCurrency, BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account, FedWire, Sender } from "model";
/**
* @class CheckingAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.checkingAccount[0];
* const checking = new CheckingAccount(record);
* @property {NUMBER} _mapID - used to map checking account information with account data

*/
   
export default class IncomingFedWire extends BCMSRecord{ 
    _mapID
    _wireNumber
    _sender
    _receivingAccount

    constructor (record) {   
      super(Object.assign(record,FedWire.initByID(record.mapID).record));
    }    

    /** 
    * @function initAll   
    * @static
    * @property {VOID} - No parameters
    * @description Returns all wires.
    * @memberof IncomingFedWire 
    */
    static initAll() {
      const wires = this._GlobalController.state[this._RecordType]

      return wires.reduce((acc, record) => {
        if(record instanceof Object) {
          acc.push(FedWire.initByType(record.mapID))
        }

        return acc;
      }, []);
    }
  }   
  IncomingFedWire.define({
    "recordType":"incomingFedWires",
    "recordIDProp":"mapID",
    "className" : "IncomingFedWire",
    "recordProperties": [
    /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the IncomingFedWire
      * @property set {NUMBER} - sets the mapID of the IncomingFedWire
      * @memberof IncomingFedWire 
      */
      BCMSRecordProperty.mapToNumber("mapID", "_mapID"),

      /** 
      * @name wireNumber
      * @instance
      * @property get {STRING} - gets the wireNumber of the IncomingFedWire
      * @property set {STRING} - sets the wireNumber of the IncomingFedWire
      * @memberof IncomingFedWire 
      */
      BCMSRecordProperty.mapToString("wireNumber", "_wireNumber"),

      /** 
      * @name sender
      * @instance
      * @property get {STRING} - gets the sendersName of the IncomingFedWire
      * @property set {STRING} - sets the sendersName of the IncomingFedWire
      * @memberof IncomingFedWire 
      */
      BCMSRecordProperty.mapToClass("sender", "_sender", () => Sender),

      /** 
      * @name receivingAccount
      * @instance
      * @property get {ACCOUNT} - gets the receivingAccount of the IncomingFedWire
      * @property set {ACCOUNT} - sets the receivingAccount of the IncomingFedWire
      * @memberof IncomingFedWire 
      */
      BCMSRecordProperty.mapToClass("receivingAccount", "_receivingAccount", () => Account),

    ].concat(FedWire._RecordProperties)
})




